export default __webpack_public_path__ + "static/media/rushi.198c4cf6.png";